<template>
  <accordion ref="accordion" v-model="mostrarAccordion">
    <div slot="header">4. Especialidades</div>
    <div v-if="!loading">
      <unicom-linha class="linha-embaixo" style="margin-bottom: 24px">
        <unicom-coluna
          sm="12"
          md="6"
          :class="$breakpoint.smAndDown ? 'mb-2' : ''"
        >
          <div class="medio segunda-cor-fonte">
            {{ nomeCampos.especialidadeAtende }}:
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="6">
          <div class="medio">
            {{ objetoInformacoes.primeiraParte.especialidadeAtende }}
          </div>
        </unicom-coluna>
      </unicom-linha>
      <unicom-linha
        style="margin-bottom: 24px"
        :class="
          indexGeral !== objetoInformacoesComputed.length - 1
            ? 'linha-embaixo'
            : ''
        "
        v-for="(objetoGeral, indexGeral) in objetoInformacoesComputed"
        :key="indexGeral"
      >
        <unicom-coluna
          sm="12"
          md="6"
          v-for="(infoPrincipal, indexPrincipal) in Object.entries(
            objetoGeral[1]
          )"
          :key="indexPrincipal"
        >
          <div
            v-for="(info, index) in Object.entries(infoPrincipal[1])"
            :key="index"
            class="medio espacamento-vertical"
          >
            <div class="segunda-cor-fonte">
              {{ nomeCampos[info[0]] }}:
              <span class="cor-fonte espacamento-horizontal">
                {{ info[1] }}
              </span>
            </div>
          </div>
        </unicom-coluna>
      </unicom-linha>
    </div>
    <unicom-spinner
      v-else
      style="min-height: 76px"
      :tamanhoLoading="62"
      :tamanhoLinha="7"
      :velocidade="0.5"
      :marginTopTexto="30"
      mensagem="Carregando..."
    />
  </accordion>
</template>

<script>
import DadosGeraisMixin from "../DadosGeraisMixin";

export default {
  name: "Especialidades",
  mixins: [DadosGeraisMixin],
  data() {
    return {
      objetoInformacoes: {
        primeiraParte: {
          especialidadeAtende: ""
        },
        principal: {
          especialidade: {
            especialidadePrincipal: "",
            possuiRqe: "",
            possuiResidencia: "",
            registroUm: 0,
            registroDois: 0,
            exibirGuiaMedico: ""
          },
          areaAtuacao: {
            areaAtuacaoPrincipal: "",
            possuiRqe: "",
            possuiResidencia: "",
            registroUm: 0,
            registroDois: 0,
            exibirGuiaMedico: ""
          }
        },
        outro: {
          especialidade: {
            especialidadeOutros: "",
            possuiRqe: "",
            possuiResidencia: "",
            registroUm: 0,
            registroDois: 0,
            exibirGuiaMedico: ""
          },
          areaAtuacao: {
            areaAtuacaoOutros: "",
            possuiRqe: "",
            possuiResidencia: "",
            registroUm: 0,
            registroDois: 0,
            exibirGuiaMedico: ""
          }
        }
      },
      nomeCampos: {
        especialidadeAtende: "Especialidade que atende",
        especialidadePrincipal: "Especialidade principal",
        areaAtuacaoPrincipal: "Área de Atuação Principal",
        especialidadeOutros: "Especialidade outros",
        areaAtuacaoOutros: "Área de atuação outros",
        possuiRqe: "Possui RQE",
        possuiResidencia: "Residência",
        exibirGuiaMedico: "Exibir no Guia Médico",
        registroUm: "Registro 1",
        registroDois: "Registro 2"
      }
    };
  },
  methods: {
    init() {
      if (this.iniciado) return;

      this.loading = true;
      this.sleep(150).then(() => {
        this.getEspecialidades(this.idRnpPrestador)
          .then(res => {
            let {
              especialidadePrincipal,
              especialidadeOutros,
              areaAtuacaoPrincipal,
              areaAtuacaoOutros,
              especialidadeAtende
            } = res.data;

            let cloneEspecialidadePrincipal = this.trocarNomeChave(
              especialidadePrincipal,
              "especialidadePrincipal"
            );
            let cloneEspecialidadeOutros = this.trocarNomeChave(
              especialidadeOutros,
              "especialidadeOutros"
            );
            let cloneAreaAtuacaoPrincipal = this.trocarNomeChave(
              areaAtuacaoPrincipal,
              "areaAtuacaoPrincipal"
            );
            let cloneAreaAtuacaoOutros = this.trocarNomeChave(
              areaAtuacaoOutros,
              "areaAtuacaoOutros"
            );

            const objetoInformacoesClone = {
              primeiraParte: {
                especialidadeAtende: especialidadeAtende.descricao
                  ? especialidadeAtende.descricao
                  : " - "
              },
              principal: {
                especialidade: this.limparObjeto(cloneEspecialidadePrincipal),
                areaAtuacao: this.limparObjeto(cloneAreaAtuacaoPrincipal)
              },
              outro: {
                especialidade: this.limparObjeto(cloneEspecialidadeOutros),
                areaAtuacao: this.limparObjeto(cloneAreaAtuacaoOutros)
              }
            };

            this.$set(this, "objetoInformacoes", objetoInformacoesClone);

            this.iniciado = true;
          })
          .catch(() => {
            this.mostrarAccordion = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    limparObjeto(objeto) {
      let cloneObjeto = JSON.parse(JSON.stringify(objeto));

      Object.entries(cloneObjeto).forEach(e => {
        if (e[1] && e[1].descricao !== undefined) {
          cloneObjeto[e[0]] = e[1].descricao
            ? e[1].descricao
            : ["possuiRqe", "possuiResidencia", "exibirGuiaMedico"].includes(
                e[0]
              )
            ? "Não"
            : " - ";
          return;
        }

        if (e[1] === null) {
          cloneObjeto[e[0]] = " - ";
          return;
        }

        cloneObjeto[e[0]] = e[1];
      });

      return cloneObjeto;
    },
    trocarNomeChave(objeto, nome) {
      return Object.assign(
        {},
        ...Object.keys(objeto).map(key => {
          if (key === "nome") {
            return {
              [nome]: objeto[key]
            };
          }

          return { [key]: objeto[key] };
        })
      );
    }
  },
  computed: {
    objetoInformacoesComputed() {
      return Object.entries(this.objetoInformacoes).filter(
        (e, index) => index > 0
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.espacamento-horizontal {
  padding-left: 8px;
}

.espacamento-vertical {
  padding-bottom: 16px;

  &:last-child {
    padding-bottom: 0px;
  }
}
</style>
